import { Button, Typography, Image } from '@smartgift/frontend-toolkit';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import RootLayout from '../layout';

import * as S from './style';

export default function Page() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const errorState = location.state || {};

  const handleReset = () => {
    navigate('/', { replace: true, state: {} });
  };

  const errorText = errorState.error?.stack?.replace(/\n/g, '%0A');
  const mailToTitle = 'Error report';
  const mailToBody = `Error: ${errorText}`;
  const supportMail = t('mailTo');
  const mailToText = `mailto:${supportMail}?subject=${mailToTitle}&body=${mailToBody}`;
  const handleReport = () => {
    window.location.href = mailToText;
    window.open(mailToText, '_blank');
  };

  return (
    <RootLayout>
      <S.ErrorPage>
        <S.ErrorPageImage>
          <Image name="error" alt="not-found" width={320} />
        </S.ErrorPageImage>
        <S.ErrorPageInformation>
          <Typography variant="subtitle1Bold">{t('globalErrorTitle')}</Typography>

          <Typography variant="subtitle4" style={{ textAlign: 'center' }}>
            <Trans
              i18nKey="globalErrorDescription"
              components={{
                a: (
                  <Button
                    onClick={handleReport}
                    variant="link"
                    color="secondary"
                    size="lg"
                    style={{ display: 'inline-flex', fontSize: 'inherit' }}
                  />
                )
              }}
            />
          </Typography>
        </S.ErrorPageInformation>

        <S.ErrorPageActions>
          <Button onClick={handleReset} variant="outlined">
            {t('goBackHome')}
          </Button>
          <Button onClick={handleReport}>{t('reportProblem')}</Button>
        </S.ErrorPageActions>
      </S.ErrorPage>
    </RootLayout>
  );
}
